import axios from 'axios'

const API_URL = 'https://qaqs.phoenixxtec.com/api/'

export default() => {
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  })
}

export const HTTP = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export const FileBuffer = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data'
  },
  responseType: 'arraybuffer'
})

export const FileUp = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data'
  }
})
